<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div class="d-flex flex-column gap-1 flex-grow-1">
      <div i18n class="detail-label">Next Payment</div>
      <app-tertiary-button i18n [size]="BaseButtonSizeEnum.xs" (buttonClicked)="viewUpcomingPayments.emit()"
        >View Upcoming Payments</app-tertiary-button
      >
    </div>
    <div i18n class="detail-value">{{ nextPaymentDate | date : 'MMMM yyyy' }}</div>
  </div>
</div>
